import { ACCESS_DOMAINS, APIMethod, fetchData } from "@client";

export async function createNewAiProjectQuery(
  userUuid,
  workspaceUuid,
  companyId,
  workTypes,
  name,
  status,
  aiPrompt,
  generatorLevel,
  generatorLanguage,
  generateDescriptions,
  generateEstimates,
  promptFiles,
) {
  const res = await fetchData("/api/project/create", APIMethod.POST, {
    baseURL: ACCESS_DOMAINS.editor,
    isJSONData: true,
    data: {
      workspaceUuid,
      userUuid,
      companyId,
      name,
      status,
      workTypes,
      aiPrompt,
      generatorLevel,
      generatorLanguage,
      generateDescriptions,
      generateEstimates,
      promptFiles,
    }
  });
  
  return res.results;
}